const widgetToastMsg = {
  /**
   *  [위젯 등록] 위젯 아이템 리스트 요청하기
   */
  GET_WIDGET_ITEM_LIST_REQUEST_SUCCESS: '위젯 아이템 리스트 요청하기 성공',
  GET_WIDGET_ITEM_LIST_REQUEST_ERROR: '위젯 아이템 리스트 요청하기 실패',

  /**
   *  [위젯 등록] 위젯 등록 요청하기
   */
  INSERT_WIDGET_REQUEST_SUCCESS: '위젯 등록 요청하기 성공',
  INSERT_WIDGET_REQUEST_ERROR: '위젯 등록 요청하기 실패',

  /**
   *  [위젯 등록] 위젯 아이템 EXCEL 다운로드하기
   */
  GET_WIDGET_ITEM_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '위젯 아이템 EXCEL 다운로드하기 성공',
  GET_WIDGET_ITEM_EXCEL_DOWNLOAD_REQUEST_ERROR: '위젯 아이템 EXCEL 다운로드하기 실패',

  /**
   *  [위젯 등록] 위젯 아이템 EXCEL 다운로드하기
   */
  GET_SELECTED_WIDGET_ITEM_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택된 위젯 아이템 EXCEL 다운로드하기 성공',
  GET_SELECTED_WIDGET_ITEM_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택된 위젯 아이템 EXCEL 다운로드하기 실패',

  /**
   *  [위젯 등록] 위젯 아이템 EXCEL 다운로드하기
   */
  SET_WIDGET_ITEM_EXCEL_UPLOAD_REQUEST_SUCCESS: '위젯 아이템 EXCEL 업로드하기 성공',
  SET_WIDGET_ITEM_EXCEL_UPLOAD_REQUEST_ERROR: '위젯 아이템 EXCEL 업로드하기 실패',

  /**
   *  [위젯 편집] 위젯 편집 요청하기
   */
  EDIT_WIDGET_REQUEST_SUCCESS: '위젯 편집 요청하기 성공',
  EDIT_WIDGET_REQUEST_ERROR: '위젯 편집 요청하기 실패',

  /**
   *  [위젯 삭제] 위젯 삭제 요청하기
   */
  DELETE_WIDGET_REQUEST_SUCCESS: '위젯 삭제 요청하기 성공',
  DELETE_WIDGET_REQUEST_ERROR: '위젯 삭제 요청하기 실패',

  /**
   * [메뉴 등록 및 편집] 메뉴 가져오기
   */
  GET_HOME_MENU_REQUEST_SUCCESS: '메뉴 가져오기 성공',
  GET_HOME_MENU_REQUEST_ERROR: '메뉴 가져오기 실패',

  /**
   *  [위젯 등록] 위젯 등록 요청하기
   */
  UPDATE_HOME_MENU_REQUEST_SUCCESS: '메뉴 업데이트 성공',
  UPDATE_HOME_MENU_REQUEST_ERROR: '메뉴 업데이트 실패',

  /**
   *  [위젯 배너 아이템 등록] 브랜드 리스트 요청하기
   */
  GET_STORE_LIST_REQUEST_SUCCESS: '브랜드 리스트 요청하기 성공',
  GET_STORE_LIST_REQUEST_ERROR: '브랜드 리스트 요청하기 실패',

  /**
   *  [위젯 배너 아이템 등록] 기획전 리스트 요청하기
   */
  GET_EVENT_LIST_REQUEST_SUCCESS: '기획전 리스트 요청하기 성공',
  GET_EVENT_LIST_REQUEST_ERROR: '기획전 리스트 요청하기 실패',

  /**
   *  [위젯 배너 아이템 등록] 상품 리스트 요청하기
   */
  GET_PRODUCT_LIST_REQUEST_SUCCESS: '상품 리스트 요청하기 성공',
  GET_PRODUCT_LIST_REQUEST_ERROR: '상품 리스트 요청하기 실패',

  /**
   * [위젯 배너 아이템 등록] 후기 리스트 요청하기
   */
  GET_REVIEW_LIST_REQUEST_SUCCESS: '후기 리스트 요청하기 성공',
  GET_REVIEW_LIST_REQUEST_ERROR: '후기 리스트 요청하기 실패',

  /**
   * [위젯 배너 아이템 등록] 후기 리스트 요청하기
   */
  GET_TAG_LIST_REQUEST_SUCCESS: '태그 리스트 요청하기 성공',
  GET_TAG_LIST_REQUEST_ERROR: '태그 리스트 요청하기 실패',

  /**
   * [위젯 배너 아이템 등록] 서브 페이지 리스트 요청하기
   */
  GET_MODAL_HOME_LIST_REQUEST_SUCCESS: '서브 페이지 리스트 요청하기 성공',
  GET_MODAL_HOME_LIST_REQUEST_ERROR: '서브 페이지 리스트 요청하기 실패',

  /**
   *  [서브 페이지 등록] 서브 페이지 등록 요청하기
   */
  INSERT_SUB_PAGE_REQUEST_SUCCESS: '서브 페이지 등록 요청하기 성공',
  INSERT_SUB_PAGE_REQUEST_ERROR: '서브 페이지 등록 요청하기 실패',

  /**
   *  [서브 페이지 편집] 서브 페이지 편집 요청하기
   */
  EDIT_SUB_PAGE_REQUEST_SUCCESS: '서브 페이지 편집 요청하기 성공',
  EDIT_SUB_PAGE_REQUEST_ERROR: '서브 페이지 편집 요청하기 실패',

  /**
   *  [서브 페이지 리스트] 서브 페이지 리스트 요청하기
   */
  GET_SUB_PAGE_LIST_REQUEST_SUCCESS: '서브 페이지 리스트 요청하기 성공',
  GET_SUB_PAGE_LIST_REQUEST_ERROR: '서브 페이지 리스트 요청하기 실패',

  /**
   *  [서브 페이지 상태] 서브 페이지 상태 업데이트 요청하기
   */
  UPDATE_SUB_PAGE_STATUS_REQUEST_SUCCESS: '서브 페이지 상태 업데이트 요청하기 성공',
  UPDATE_SUB_PAGE_STATUS_REQUEST_ERROR: '서브 페이지 상태 업데이트 요청하기 실패',

  /**
   *  [서브 페이지 삭제] 서브 페이지 삭제 요청하기
   */
  DELETE_SUB_PAGE_REQUEST_SUCCESS: '서브 페이지 삭제 요청하기 성공',
  DELETE_SUB_PAGE_REQUEST_ERROR: '서브 페이지 삭제 요청하기 실패',

  /**
   *  [메인 페이지 위젯 리스트] 메인 페이지 위젯 리스트 요청하기
   */
  GET_MAIN_PAGE_WIDGET_LIST_REQUEST_SUCCESS: '메인 페이지 위젯 리스트 요청하기 성공',
  GET_MAIN_PAGE_WIDGET_LIST_REQUEST_ERROR: '메인 페이지 위젯 리스트 요청하기 실패',

  /**
   *  [서브 페이지 위젯 리스트] 서브 페이지 위젯 리스트 요청하기
   */
  GET_SUB_PAGE_WIDGET_LIST_REQUEST_SUCCESS: '서브 페이지 위젯 리스트 요청하기 성공',
  GET_SUB_PAGE_WIDGET_LIST_REQUEST_ERROR: '서브 페이지 위젯 리스트 요청하기 실패',

  /**
   *  [위젯 전체 리스트] 위젯 전체 리스트 요청하기
   */
  GET_WIDGET_ALL_LIST_REQUEST_SUCCESS: '위젯 전체 리스트 요청하기 성공',
  GET_WIDGET_ALL_LIST_REQUEST_ERROR: '위젯 전체 리스트 요청하기 실패',

  /**
   *  [위젯 비활성 리스트] 위젯 비활성 리스트 요청하기
   */
  GET_WIDGET_INACTIVE_LIST_REQUEST_SUCCESS: '위젯 비활성 리스트 요청하기 성공',
  GET_WIDGET_INACTIVE_LIST_REQUEST_ERROR: '위젯 비활성 리스트 요청하기 실패',

  /**
   *  [위젯 리스트] 변경된 위젯 리스트 저장하기
   */
  SAVE_UPDATED_WIDGET_LIST_REQUEST_SUCCESS: '변경된 위젯 리스트 저장하기 성공',
  SAVE_UPDATED_WIDGET_LIST_REQUEST_ERROR: '변경된 위젯 리스트 저장하기 실패',

  /**
   *  [위젯 리스트] 변경된 전체 위젯 리스트 저장하기
   */
  SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST_SUCCESS: '변경된 전체 위젯 리스트 저장하기 성공',
  SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST_ERROR: '변경된 전체 위젯 리스트 저장하기 실패',

  /**
   *  [위젯 상세] 위젯 상세 데이터 요청하기
   */
  GET_WIDGET_DETAIL_REQUEST_SUCCESS: '위젯 상세 데이터 요청하기 성공',
  GET_WIDGET_DETAIL_REQUEST_ERROR: '위젯 상세 데이터 요청하기 실패',

  /**
   *  [위젯 리스트] 위젯 미리보기 데이터 요청하기
   */
  GET_WIDGET_PREVIEW_DATA_REQUEST_SUCCESS: '위젯 미리보기 데이터 요청하기 성공',
  GET_WIDGET_PREVIEW_DATA_REQUEST_ERROR: '위젯 미리보기 데이터 요청하기 실패',

  /**
   *  [위젯 리스트] 기간에 따른 위젯 미리보기 데이터 요청하기
   */
  GET_WIDGET_PREVIEW_PERIOD_DATA_REQUEST_SUCCESS: '기간에 따른 위젯 미리보기 데이터 요청하기 성공',
  GET_WIDGET_PREVIEW_PERIOD_DATA_REQUEST_ERROR: '기간에 따른 위젯 미리보기 데이터 요청하기 실패',
};

export default widgetToastMsg;
